import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { useTranslation } from 'react-i18next';
import { BenefitPaper } from '../../component/benefitTabs/BenefitPaper';
import { getBenefitIcon } from '../../module/benefits/BenefitIcon';
import BenefitSubPage from '../../module/benefits/BenefitSubPage';
import { useAdditionalBikeleasingColumns } from '../../module/benefits/bikeleasingV2/useAdditionalBikeleasingColumns';
import { useBikeleasingPrecondition } from '../../module/benefits/bikeleasingV2/useBikeleasingPrecondition';
import { AuthorizedLayout } from '../../module/navigation/AuthorizedLayout';
import { BenefitEmployeesPage } from '../benefit/BenefitEmployeesPage';

export function BikeleasingEmployeesPage() {
  const { t } = useTranslation('benefitsModule');
  const { isPreconditionMet, PreconditionComponent } = useBikeleasingPrecondition();
  const benefit = BenefitDTOBenefitEnum.BikeleasingV2;
  const additionalColumns = useAdditionalBikeleasingColumns();

  return isPreconditionMet ? (
    <BenefitEmployeesPage benefit={benefit} additionalColumns={additionalColumns} />
  ) : (
    <AuthorizedLayout
      title={t('subPage.employees')}
      breadcrumbs={[{ title: t(`${benefit}.title`), to: `/benefits/${benefit.toLowerCase()}` }]}
    >
      <BenefitSubPage
        icon={getBenefitIcon(BenefitDTOBenefitEnum.BikeleasingV2)}
        title={t('extensions:bikeleasing_v2.title')}
        subTitle={t('subPage.employees')}
      >
        <BenefitPaper>{PreconditionComponent}</BenefitPaper>
      </BenefitSubPage>
    </AuthorizedLayout>
  );
}
